<template>
  <div class="floatnavRight">
    <ul class="floatnav-inner" v-if="this.$lang.current === 'cn'">
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="技术支持"
          placement="left"
        >
          <el-button type="text" class="click-opened" @click="showDialog">
            <i class="iconfont icon-contact"></i>
          </el-button>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="商城"
          placement="left"
        >
          <a href="https://shop.lerdge.com/" target="_blank">
            <i class="iconfont icon-shangcheng"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Lerdge淘宝店铺"
          placement="left"
        >
          <a
            href="https://lerdge.taobao.com/?ali_refid=a3_430582_1006:1124108243:N:tPX0OOjZJDUPbeTWbjJdNnVxV3dNIHPA:bcf433ce98bc107bee3473b91082701b&ali_trackid=1_bcf433ce98bc107bee3473b91082701b&spm=a230r.1.14.4"
            target="_blank"
            data-spm-anchor-id="a1z10.3-c-s.0.0"
          >
            <i class="iconfont icon-taobao"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="哔哩哔哩"
          placement="left"
        >
          <a href="https://space.bilibili.com/1983199993" target="_blank">
            <i class="iconfont icon-bilibili-copy-copy"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="抖音"
          placement="left"
        >
          <a href="https://www.douyin.com/user/MS4wLjABAAAAw-Hki1U_UmKNfF8IFbX_Fye1v_jcraZYEMLsIvf4hWM" target="_blank">
            <i class="iconfont icon-douyin"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="返回顶部"
          placement="left"
        >
          <el-button type="text" class="click-opened" @click="backtop()">
            <i class="iconfont icon-backtop"></i>
          </el-button>
        </el-tooltip>
      </li>
    </ul>
    <ul class="floatnav-inner" v-else>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Support"
          placement="left"
        >
          <el-button type="text" class="click-opened" @click="showDialog">
            <i class="iconfont icon-contact"></i>
          </el-button>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Shop"
          placement="left"
        >
          <a href="https://shop.lerdge.com/" target="_blank">
            <i class="iconfont icon-shangcheng"></i>
          </a>
        </el-tooltip>
      </li>

      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Aliexpress"
          placement="left"
        >
          <a href="https://lerdge.aliexpress.com/" target="_blank">
            <i class="iconfont icon-sumaitong2"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Facebook"
          placement="left"
        >
          <a
            href="https://www.facebook.com/groups/594873880921802"
            target="_blank"
          >
            <i class="iconfont icon-icon-facebook"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Youtube"
          placement="left"
        >
          <a href="https://www.youtube.com/channel/UCS0bM7-MhgW5B0L2XJ3zUDg/videos" target="_blank">
            <i class="iconfont icon-youtube1"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Instagram"
          placement="left"
        >
          <a href="https://www.instagram.com/lerdge3d/" target="_blank">
            <i class="iconfont icon-instagram-fill"></i>
          </a>
        </el-tooltip>
      </li>
      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Twitter"
          placement="left"
        >
          <a href="https://twitter.com/lerdge" target="_blank">
            <i class="iconfont icon-twitter1"></i>
          </a>
        </el-tooltip>
      </li>

      <li>
        <el-tooltip
          class="item"
          effect="dark"
          content="Back top"
          placement="left"
        >
          <el-button type="text" class="click-opened" @click="backtop()">
            <i class="iconfont icon-backtop"></i>
          </el-button>
        </el-tooltip>
      </li>
    </ul>

    <div class="douyincode" v-show="douyincode">
      <img src="@/assets/images/douyin.png" />
    </div>
    <el-dialog
      :title="$lang.com('ContactTitle')"
      :visible.sync="dialogFormVisible"
      @closed="dialogClosed"
      @opened="dialogOpened"
      :close-on-click-modal="false"
      v-loading="loading"
    >
      <div class="tip">
        {{ $lang.com("Tips") }}&nbsp;
        <b>support@lerdge.com</b>
        &nbsp;{{ $lang.com("ThisMailbox") }}
        <em>
          {{ $lang.com("Worktime") }}
          <b>{{ $lang.com("MondayToFriday") }}</b>
        </em>
      </div>
      <el-form
        :model="form"
        ref="form"
        :rules="contactRules"
        @submit.native.prevent="submitForm"
      >
        <el-form-item
          :label="$lang.com('YourEmail')"
          :label-width="formLabelWidth"
          prop="email"
        >
          <el-input v-model="form.email" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          :label="$lang.com('YourProblem')"
          :label-width="formLabelWidth"
          prop="content"
        >
          <el-input
            type="textarea"
            :rows="10"
            :placeholder="$lang.com('DescribeProblem')"
            v-model="form.content"
          ></el-input>
          <em class="tip" v-if="isShowTip">
            <i class="iconfont icon-tip"></i>
            In order to help you better solve the problem, please try to express
            it in English.
          </em>
        </el-form-item>

        <el-form-item
          :label="$lang.com('AddPicture')"
          :label-width="formLabelWidth"
        >
          <el-upload
            ref="elUpload"
            action
            list-type="picture-card"
            accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
            :limit="3"
            :http-request="upload"
            :on-preview="uploadPreview"
            style="text-align: left"
          >
            <i class="iconfont icon-jia"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="slideverify">
          <div id="captcha" class="nc-container"></div>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogFormVisible = false" class="white" round>{{
            $lang.com("Cancel")
          }}</el-button>
          <el-button :loading="loading" native-type="submit" round>{{
            $lang.com("Submit")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import noCaptcha from "noCaptcha";
import { contactUs } from "@/api/mail.js";
import request from "@/utils/request";
let formTemplate = () => {
  return {
    content: "",
    email: "",
    scene: "",
    session_id: "",
    sig: "",
    token: "",
  };
};
export default {
  data() {
    return {
      douyincode: false,
      isLangCn: false,
      // toChangeLink: "",
      loading: false,
      dialogFormVisible: false,
      form: formTemplate(),
      dialogImageUrl: "",
      files: [],
      captcha: {
        ctrl: undefined,
        token: "",
        scene: "",
      },
      contactRules: {
        email: [
          {
            required: true,
            message: this.$lang.com("IsRequired"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$lang.com("IsEmail"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$lang.com("IsRequired"),
          },
        ],
      },
      formLabelWidth: "120px",
      isShowTip: false,
    };
  },
  methods: {
    init() {
      this.isLangCn = this.$lang.current === "cn";
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid && this.form.session_id != "") {
          let content = this.form.content;
          this.loading = true;
          if (this.files.length > 0) {
            content += "<br/>";
            this.files.slice(-3).forEach((x) => {
              content += `<img src="${x.file_url}" alt="${x.file_nike}"/><br/>`;
            });
          }
          var requestForm = {
            content:
              `<a href="mailto:${this.form.email}?subject=Lerdge Support Team Reply" style="display:block;width:100px;height:30px;border-raidus:2px;padding:0 10px;background:#0077e6;color:#fff;text-align:center;margin:0 10px;line-height:30px;font-size:12px;">回复</a><br/>` +
              content,
            email: this.form.email,
            scene: this.form.scene,
            session_id: this.form.session_id,
            sig: this.form.sig,
            token: this.form.token,
          };
          contactUs(requestForm).then((resp) => {
            if (resp.success) {
              this.dialogFormVisible = false;
            } else {
              this.resetCaptcha();
              alert(resp.msg);
            }
            this.loading = false;
          });
        }
      });
    },
    captchaCallback(data) {
      this.form.scene = this.captcha.scene;
      this.form.token = this.captcha.token;
      this.form.session_id = data.csessionid;
      this.form.sig = data.sig;
    },
    resetForm() {
      this.form = formTemplate();
      this.files = [];
      this.resetCaptcha();
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
        this.$refs["elUpload"].clearFiles();
      });
    },
    resetCaptcha() {
      this.form.session_id = "";
      this.form.sig = "";
      this.captcha.ctrl.reload();
    },
    dialogClosed() {
      this.resetForm();
    },
    dialogOpened() {
      if (!this.captcha.ctrl) {
        this.captcha.token = [
          "FFFF0N00000000008D57",
          new Date().getTime(),
          Math.random(),
        ].join(":");
        this.captcha.scene = "nc_other";
        var captchaOpt = {
          renderTo: "#captcha",
          appkey: "FFFF0N00000000008D57",
          scene: this.captcha.scene,
          token: this.captcha.token,
          language: this.$lang.current,
          timeout: 3000,
          times: 5,
          timer: "",
          callback: this.captchaCallback,
        };
        this.captcha.ctrl = new noCaptcha(captchaOpt);
        this.captcha.ctrl.upLang("cn", {
          _startTEXT: this.$lang.com("StartText"),
          _yesTEXT: this.$lang.com("YesTest"),
          _error300:
            '${this.$lang.com("ErrorText1")} <a href="javascript:__nc.reset()">this.$lang.com("ErrorText2")</a> ${this.$lang.com("ErrorText3")}',
          _errorNetwork:
            'this.$lang.com("ErrorNetWord1")<a href="javascript:__nc.reset()">this.$lang.com("ErrorNetWord2")</a>',
        });
      }
    },
    showDialog() {
      this.isShowTip = this.$lang.current === "en";
      this.dialogFormVisible = true;
    },
    showDouyinCode() {
      this.douyincode = true;
    },
    hideDouyinCode() {
      this.douyincode = false;
    },
    upload(params) {
      this.loading = true;

      const file = params.file;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error({
          message: this.$lang.com("UploadSize"),
          type: "error",
        });
      } else {
        let data = new FormData();
        data.append("file", file);
        request({
          url: "/Upload/uploadFile",
          method: "post",
          data: data,
          headers: { "Content-Type": "multipart/form-data" },
        }).then((resp) => {
          if (resp.success) {
            this.files.push(resp.data);
          } else {
            this.$message.error({
              message: resp.msg,
              type: "error",
            });
          }
          this.loading = false;
        });
      }
    },
    uploadPreview(file) {
      this.dialogImageUrl = file.url;
    },
    //中英文切换
    // toChange() {
    //   if (this.$lang.current === "en") {
    //     this.toChangeLink = "//www.lerdge.cn";
    //   } else {
    //     this.toChangeLink = "//www.lerdge.com";
    //   }
    // },
    handleScroll() {
      if (document.documentElement.scrollTop > 50) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    backtop(step) {
      document.documentElement.scrollTop -= step;
      if (document.documentElement.scrollTop > 0) {
        var time = setTimeout(() => this.toTop(step), 15);
      } else {
        clearTimeout(time);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  created() {
    this.init();
  },
  computed: {
    dialogVisible() {
      return this.dialogImageUrl != "";
    },
  },
};
</script>